module.exports = __webpack_public_path__ + "static/media/folder2.e045a16d.svg";